import React, { useEffect, useState } from "react";
import { useHomeStore } from "../../store/useHomeStore";
import { useNavigate } from "react-router";
import Loader from "../../Components/Loader";

const Capability = () => {
    let { capability, getCapability, postCapability } = useHomeStore();
    const navigate = useNavigate()
    const [localCapability, setLocalCapability] = useState([]);
    const [openIndex, setOpenIndex] = useState(null);
    const [editIndex, setEditIndex] = useState(null);
    const [loading, setLoading] = useState(false);

    const toggleDropdown = (index, flag) => {
        if (flag) {
            let presentIndex = openIndex === index ? null : index
            setOpenIndex(openIndex === index ? null : index);
            if (!presentIndex || presentIndex != editIndex)
                setEditIndex(null);
        }
        else {
            setEditIndex(editIndex === index ? null : index);
        }
    };

    const getCapabilityData = async () => {
        setLoading(true)
        await getCapability();
        setLoading(false)
    };

    useEffect(() => {
        getCapabilityData();
    }, []);


    useEffect(() => {
        setLocalCapability(capability || []);
    }, [capability]);


    const handleTitleChange = (i, value) => {
        const updated = [...localCapability];
        updated[i].title = value;
        setLocalCapability(updated);
    };


    const addCapability = () => {
        setLocalCapability([
            ...localCapability,
            { title: "", points: [] },
        ]);
    };


    const addPoint = (i) => {
        const updated = [...localCapability];
        updated[i].points.push({ title: "", description: "" });
        setLocalCapability(updated);
    };


    const handlePointChange = (i, j, field, value) => {
        const updated = [...localCapability];
        updated[i].points[j][field] = value;
        setLocalCapability(updated);
    };

    const handleSubmit = async () => {
        setLoading(true)
        await postCapability(localCapability)
        setEditIndex(null)
        setOpenIndex(null)
        setLoading(false)
    }

    const handleDelete = (i, j) => {
        setLocalCapability((prev) => {
            return prev.map((cap, index) => {
                if (index === i) {
                    return {
                        ...cap,
                        points: cap.points.filter((_, idx) => idx !== j),
                    };
                }
                return cap;
            });
        });
    };


    return (
        <div>
            <div className="bg-white rounded-md shadow-sm border border-neutral-200 overflow-hidden">
                {/* Header */}
                <div className="px-6 py-4 border-b border-neutral-200 bg-neutral-50 flex justify-between items-center">
                    <h3 className="font-bold">Company Capability</h3>
                    {/* <button
                        onClick={addCapability}
                        className="text-sm px-3 py-1 rounded bg-green-500 text-white hover:bg-green-600"
                    >
                        + Add Capability
                    </button> */}
                </div>
                <Loader loading={loading}>

                    <div className="w-full mx-auto border rounded-lg shadow">
                        {(localCapability || []).map((ele, i) => (
                            <div key={i} className="border-b border-black">
                                <div
                                    className="px-6 py-4 bg-gray-200 flex justify-between items-center cursor-pointer"
                                >
                                    {
                                        editIndex === i ?
                                            <input
                                                type="text"
                                                value={ele?.title}
                                                onChange={(e) => handleTitleChange(i, e.target.value)}
                                                className="font-semibold bg-transparent w-full border-b border-dashed border-gray-400 focus:outline-none"
                                            /> :
                                            <span className="font-semibold" onClick={() => toggleDropdown(i, true)}>{ele?.title}</span>
                                    }
                                    <div className="flex gap-4">
                                        {
                                            openIndex === i && <i className="fa-solid fa-edit" onClick={() => toggleDropdown(i, false)}></i>
                                        }
                                        <span className="text-sm" onClick={() => toggleDropdown(i, true)}>
                                            {openIndex === i ? "▲" : "▼"}
                                        </span>
                                    </div>
                                </div>


                                {openIndex === i && (
                                    <div className="bg-gray-50 px-6 py-4 space-y-3">
                                        {(ele?.points || []).map((point, j) => (
                                            <div
                                                key={j}
                                                className="p-3 border rounded-lg bg-white shadow-sm space-y-2"
                                            >
                                                {
                                                    (editIndex === i) ?
                                                        <div className="flex">
                                                            <div className="w-[90%]">
                                                                <input
                                                                    type="text"
                                                                    value={point?.title}
                                                                    onChange={(e) =>
                                                                        handlePointChange(i, j, "title", e.target.value)
                                                                    }
                                                                    className="w-full p-2 border rounded-md"
                                                                    placeholder="Point Title"
                                                                />
                                                                <textarea
                                                                    value={point?.description}
                                                                    onChange={(e) =>
                                                                        handlePointChange(i, j, "description", e.target.value)
                                                                    }
                                                                    className="w-full p-2 border rounded-md"
                                                                    rows={3}
                                                                    placeholder="Point Description"
                                                                    maxLength={1000}
                                                                />
                                                            </div>

                                                            <button
                                                                className="text-neutral-500 hover:text-neutral-600 w-[10%]"
                                                                onClick={() => handleDelete(i, j)}
                                                            >
                                                                <i className="fa-solid fa-trash-alt"></i>
                                                            </button>
                                                        </div> :
                                                        <div>
                                                            <h4 className="font-medium">{point?.title}</h4>
                                                            <p className="text-sm text-neutral-600">{point?.description}</p>
                                                        </div>
                                                }
                                            </div>
                                        ))}
                                        {
                                            (editIndex === i) &&
                                            <button
                                                onClick={() => addPoint(i)}
                                                className="px-4 py-2 bg-neutral-900 text-white rounded-md"
                                            >
                                                + Add Point
                                            </button>
                                        }

                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </Loader>
            </div>

            <div className="flex justify-end space-x-3 mt-6">

                <button
                    className="px-4 py-2 bg-neutral-900 text-white rounded-md"
                    onClick={() => handleSubmit()}
                >
                    Save Capability
                </button>
            </div>
        </div>
    );
};

export default Capability;
